import { useDispatch, useSelector } from 'react-redux';
import { useAllInPricingVariant, ALL_IN_PRICING_VARIANTS, } from 'hooks/use-all-in-pricing-variant';
import { SearchPageView } from 'utils/search-page-view';
import { setAllInPricingCalloutAnimationComplete } from 'store/search/search-actions';
import { getSearchView } from 'store/selectors/selectors';
export const useAllInPricingMobile = () => {
    const dispatch = useDispatch();
    const variant = useAllInPricingVariant();
    const view = useSelector(getSearchView);
    const handleAnimationComplete = () => {
        // Wait 3 seconds after animation completes before allowing popovers to show
        setTimeout(() => {
            dispatch(setAllInPricingCalloutAnimationComplete(true));
        }, 3000);
    };
    const showMobileCallout = variant === ALL_IN_PRICING_VARIANTS.ON_WITH_MARKETING &&
        view !== SearchPageView.DESKTOP_LIST;
    return {
        showMobileCallout,
        handleAnimationComplete,
    };
};
